export { default as Information } from './Information';


// WEBPACK FOOTER //
// ./src/components/Information/index.jsx